import React, { useState, useEffect } from 'react';
import { dateFormater } from '../../utils/utilities';
import { useNavigate } from 'react-router-dom';
import * as Assets from '../../utils/svg_assets';
import * as PageRoutes from '../../utils/route_pages';
import { Row, Col, ListGroup, Form, Button } from 'react-bootstrap';
import ApiUtils from '../../utils/api_utils';
import NotFound from '../../components/NotFound';

const ListVoucher = (props) => {
  const navigate = useNavigate();
  const { myvoucher, activeTabs, hitParams, setHitParams, isLoading } = props;
  const [search, setSearch] = useState('');
  const [voucherData, setVoucherData] = useState(myvoucher.results);

  useEffect(() => {
    let dataFilter = myvoucher.results;

    if (activeTabs === 'used') {
      dataFilter = myvoucher.results.filter(
        (item) => item.is_used === true || item.is_expired === true
      );
    } else if (activeTabs === 'available') {
      dataFilter = myvoucher.results.filter(
        (item) => item.is_used === false && item.is_expired === false
      );
    }

    const data = dataFilter.filter((item) => {
      const itemName = item.reward.name.toLowerCase();
      const itemlist = itemName.includes(search.toLowerCase());
      return itemlist;
    });
    setVoucherData(data);
  }, [search]);

  useEffect(() => {
    const data = myvoucher.results;
    setVoucherData(data);
  }, [myvoucher.results]);

  useEffect(() => {
    setSearch('');
  }, [hitParams]);

  useEffect(() => {
    let dataFilter = myvoucher.results;

    if (activeTabs === 'used') {
      dataFilter = myvoucher.results.filter(
        (item) => item.is_used === true || item.is_expired === true
      );
    } else if (activeTabs === 'available') {
      dataFilter = myvoucher.results.filter(
        (item) => item.is_used === false && item.is_expired === false
      );
    }

    setVoucherData(dataFilter);
  }, [activeTabs]);

  const LoadingSpinner = () => (
    <div className="loading-overlay">
      <div className="loading-spinner"></div>
    </div>
  );

  return (
    <div className="list-voucher">
      <div>
        <Col xs={11} sm={11} md={11} className="search-voucher">
          <Form.Control
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </Col>
      </div>
      {myvoucher.results.length > 0 && (
        <Row className="pagination">
          <div className="pagination-voucher">
            <Row>
              <Col xs={3} sm={3} md={3} className="pagination-left">
                {myvoucher.previous && (
                  <img
                    src={Assets.iconArrowLeft}
                    onClick={() => {
                      setHitParams({ ...hitParams, page: hitParams.page - 1 });
                    }}
                    className="pagination-left-image"
                    alt="cl_image"
                  />
                )}
              </Col>
              <Col xs={6} sm={6} md={6} className="pagination-center">
                {`Page ${hitParams.page}`}
              </Col>
              <Col xs={3} sm={3} md={3} className="pagination-right">
                {myvoucher.next && (
                  <img
                    src={Assets.iconArrowRight}
                    onClick={() => {
                      setHitParams({ ...hitParams, page: hitParams.page + 1 });
                    }}
                    className="pagination-right-image"
                    alt="cr_image"
                  />
                )}
              </Col>
            </Row>
          </div>
        </Row>
      )}
      {isLoading ? (
        <LoadingSpinner />
      ) : myvoucher.results.length === 0 ? (
        <NotFound
          img={Assets.snapReceiptNotFound}
          title="You have no voucher"
          subTitle="Stay tune for more voucher."
        />
      ) : (
        <Row className="my-voucher-list">
          <ListGroup>
            {myvoucher
              ? voucherData.map((item, index) => (
                  <ListGroup.Item
                    key={index}
                    className={
                      item.is_used === true || item.is_expired === true
                        ? 'grey-list'
                        : ''
                    }
                  >
                    <Row>
                      <Col xs={3} sm={3} md={3}>
                        <img
                          src={ApiUtils.validateImgUrl({
                            url: item.reward.thumbnail_img_url,
                          })}
                          className="voucher-image"
                          alt="myvoucher_image"
                        />
                      </Col>
                      <Col xs={6} sm={6} md={6} className="voucher-detail">
                        <div className="voucher-title">{item.reward.name}</div>
                        <div className="voucher-info">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.reward.description,
                            }}
                          />
                        </div>
                        <div className="voucher-expired">
                          Voucher valid until{' '}
                          {dateFormater(item.evoucher_valid_until)}
                        </div>
                      </Col>
                      <Col xs={3} sm={3} md={3} className="btn-voucher">
                        <Button
                          variant="danger"
                          onClick={() => {
                            navigate(
                              `${PageRoutes.myVoucher}/detail/${item.id}`
                            );
                          }}
                          disabled={
                            item.is_used === true || item.is_expired === true
                              ? true
                              : false
                          }
                          className="btn-voucher-used"
                        >
                          {item.is_used === true
                            ? 'Used'
                            : item.is_expired === true
                            ? 'Expired'
                            : 'Use'}
                        </Button>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                ))
              : ''}
          </ListGroup>
        </Row>
      )}
    </div>
  );
};

export default ListVoucher;
